
import React, {FC, useEffect} from 'react';
import {Endpoints, postValues} from 'utils/n8n';

import {Agent} from './Agent';
import {Feedback} from './Feedback';
import {Preparing} from './Preparing';
import {useState} from './reducer';
import {ThankYou} from './ThankYou';

type VoiceControlProps = {
	onClose: () => void
	onReport: (report: string) => void
}

export const VoiceControl: FC<VoiceControlProps> = ({onClose, onReport}) => {
	const {state, dispatch} = useState();

	// If our feedback is newly set, send it to Airtable
	useEffect(() => {
		if (state.feedback) {
			postValues(Endpoints.voiceFeedback, {
				report: state.report,
				feedback: JSON.stringify(state.feedback),
			});
		}
	}, [state.feedback]);

	// Figure out what we should show to the user
	switch (state.show) {
	case 'preparing':
		return (
			<Preparing onReport={
				(report, source) => {
					dispatch({type: 'REPORT', report, source});
					onReport(source); // send back report cache
				}
			} />
		);

	case 'agent':
		return (
			<Agent report={state.report} onState={
				(agent) => dispatch({
					type: 'AGENT',
					agent,
				})
			} />
		);

	case 'feedback':
		return (
			<Feedback onFeedback={
				(feedback, final) => dispatch({
					type: 'FEEDBACK',
					feedback,
					final,
				})
			} />
		);

	case 'thank-you':
		return (
			<ThankYou onClose={onClose} />
		);
	}
};
